// extracted by mini-css-extract-plugin
export var actionButton = "_qu-0";
export var actionMenuContainer = "_qu-i";
export var bubble = "_qu-2";
export var bubbleActionMenu = "_qu-j";
export var bubbleContext = "_qu-6";
export var bubbleItems = "_qu-7";
export var customer = "_qu-3";
export var divider = "_qu-8";
export var fileList = "_qu-9";
export var hiddenComment = "_qu-o";
export var infoAbove = "_qu-a";
export var internal = "_qu-4";
export var lightActionButton = "_qu-1";
export var link = "_qu-b";
export var merchant = "_qu-5";
export var message = "_qu-c";
export var profilePicture = "_qu-e";
export var quillToolbarContainer = "_qu-f";
export var senderDate = "_qu-g";
export var senderDateCustomer = "_qu-h";
export var senderName = "_qu-d";
export var time = "_qu-k";
export var uploadedImage = "_qu-l";
export var username = "_qu-m";
export var xsmall = "_qu-n";